<template>
        <input 
            v-model="inputValue" 
            type="text" 
            class="form-control" 
            id="autocomplete" 
            :placeholder="myPlaceHolder"
            @focus="handleFocus" 
            @blur="handleBlur" 
            @input="handleInput"
            ref="inputRef"
            autocomplete="off"
            :disabled="disabled"
        >
        <ul
            v-if="filteredOptionsList.length"
            class="w-100 rounded bg-white px-3 py-2 position-absolute top-101 start-0 z-20 shadow"
            style="list-style-type: none;"
        >
            <li
                v-for="option in filteredOptionsList"
                :key="option"
                @click="selectOption(option)"
                class="curClickable hover-bg-gray-200 p-1"
            >
                {{ option }}
            </li>
        </ul>

</template>

<script>
import { computed, ref, watch } from 'vue';
import Fuse from 'fuse.js';

export default {
    name: 'AutoComplete',
    emits: ['selected', 'input', 'focus'],
    props: {
        options: {
            type: Array,
            required: true
        },
        myPlaceHolder: {
            type: String,
            default: '...',
            required: false
        },
        initialValue: {
            type: String,
            default: '',
            required: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    setup(props, { emit }) {
        const inputValue = ref(props.initialValue);
        const selectedOption = ref('');
        const filteredOptionsList = ref([]);
        const inputRef = ref(null);

        const fuse = computed(() => new Fuse(props.options, {
            threshold: 0.3,
            distance: 100,
            minMatchCharLength: 1,
        }));

        const MAX_RESULTS = 10;

        watch(() => props.initialValue, (newValue) => {
            inputValue.value = newValue;
        });

        const filteredOptions = computed(() => {
            if (!selectedOption.value || !inputValue.value || inputValue.value.trim() === '') {
                return [];
            }

            return fuse.value.search(inputValue.value)
                .map(result => result.item)
                .slice(0, MAX_RESULTS);
        });

        watch(filteredOptions, (newValue) => {
            filteredOptionsList.value = newValue;
        });

        const selectOption = (option) => {
            inputValue.value = option;
            emit('selected', option);
            selectedOption.value = '';
        };
        
        const handleFocus = () => {
            selectedOption.value = inputValue.value;
            emit('focus');
        };

        const handleBlur = () => {
            setTimeout(() => {
                selectedOption.value = '';
            }, 200);
        };

        const handleInput = () => {
            selectedOption.value = inputValue.value;
            emit('input', selectedOption.value);
        };

        const focusAndSelect = (start, end) => {
            if (inputRef.value) {
                inputRef.value.focus();
                inputRef.value.setSelectionRange(start, end);
            }
        };

        return {
            inputValue,
            filteredOptions,
            handleFocus,
            handleBlur,
            handleInput,
            selectOption,
            filteredOptionsList,
            inputRef,
            focusAndSelect
        }
    }
}
</script>

<style lang="scss" scoped>
.top-101 {
  top: calc(100% + 10px);
}
.hover-bg-gray-200:hover {
  background: #e9ecef;
}
@keyframes highlight {
  0% { background-color: #ffffff; }
  50% { background-color: #e0f7fa; }
  100% { background-color: #ffffff; }
}

.highlight-animation {
  animation: highlight 2s ease-in-out;
}
</style>